import { useEffect } from 'react';
import useFetch, { muteErrorAndResult } from 'hooks/useFetch';
import { useAppSelector } from 'store/hooks';
import { StaticCollectionIds } from '../types';
import { selectActiveTradingAccountBroker, selectActiveTradingAccountId, selectStaticCollections, } from '../reducers/selectors';
import { getStaticCollectionsStocks, getTopTrendingStocks } from '../actions';
/**
 * Biggest daily movers stocks are fetched and cached into persisted store.
 * This hook will fire an API request to update the list of biggest daily movers on mount.
 */
const useStaticCollections = (type) => {
    const list = useAppSelector((store) => selectStaticCollections(store, type));
    const broker = useAppSelector(selectActiveTradingAccountBroker);
    const tradingAccountId = useAppSelector(selectActiveTradingAccountId);
    const [, , fetching, fetch] = useFetch(muteErrorAndResult);
    useEffect(() => {
        if (type === 'TOP_TRENDING') {
            if (broker && tradingAccountId) {
                fetch(getTopTrendingStocks(100, broker, tradingAccountId));
            }
        }
        else {
            fetch(getStaticCollectionsStocks(type, type === StaticCollectionIds.HIGHEST_MARKET_CAP || type === StaticCollectionIds.MOST_POPULAR ? 100 : 20));
        }
    }, [broker, tradingAccountId, type]);
    return { fetching, list };
};
export default useStaticCollections;
